export default {
  conditions: {
    id: 'grades_modal_condition',
    defaultMessage: 'Conditions',
  },
  moreInfo: {
    id: 'grades_modal_more_info',
    defaultMessage: 'More info',
  },
  alreadySold: {
    id: 'already_sold',
    defaultMessage: 'Sold out',
  },
}
